import React from "react"
import PropTypes from "prop-types"
import styles from "./HowDoesItWorkRow.module.css"
import HowDoesItWorkCard from "./HowDoesItWorkCard"

const HowDoesItWorkRow = ({ classNames = [], cards, iconColor }) => (
  <section className={`${styles.cards} ${classNames ? classNames.map(className => styles[className]).join(" ") : ""}`}>
    {
      (cards && cards.length > 0) &&
      cards.map((card, cardIndex) => <HowDoesItWorkCard {...card} iconColor={iconColor} key={`card${card.header}${cardIndex}`}/>)
    }
  </section>
)

HowDoesItWorkRow.propTypes = {
  classNames: PropTypes.array,
  cards: PropTypes.arrayOf(PropTypes.shape({
    header: PropTypes.string,
    icon: PropTypes.string,
    content: PropTypes.any,
    link: PropTypes.string,
  })),
  iconColor: PropTypes.string,
}

export default HowDoesItWorkRow